import { $api } from "@/lib/api-client";

export const useFetchFirstWeek = () => {
  return $api.useQuery("get", "/nft/first-order-date", {});
};
